import * as React from 'react';
import { AptunoButton, Icon, SIZES, VARIANTS } from '@aptuno/aptuno-ui';
import { ActionBarContainer } from './styled';
import { usePublicationRouter } from '@contexts/PropertyListingPublications/components/shared';
import { Grid } from '@mui/material';

export type ProcessActionBarProps = {
  primary: {
    name: string;
    onClick: () => void;
    disabled?: boolean;
  };
  disabled?: boolean;
};

export const ProcessActionBar = (props: ProcessActionBarProps) => {
  const { primary, disabled = false } = props;

  const router = usePublicationRouter();

  const hasGoBack = router.hasGoBack;
  return (
    <ActionBarContainer>
      <Grid container>
        <Grid item xs={hasGoBack ? 4 : 0}>
          {hasGoBack && (
            <AptunoButton
              size={SIZES.SMALL}
              appearance={VARIANTS.SECONDARY}
              onClick={() => router.goToPreviousStep()}
              disabled={disabled}
            >
              <Icon icon={'arrowleftalt'} />
              Regresar
            </AptunoButton>
          )}
        </Grid>
        <Grid item xs={hasGoBack ? 8 : 12}>
          <AptunoButton
            appearance={VARIANTS.PRIMARY}
            size={SIZES.BIG}
            isDisabled={disabled || primary.disabled}
            onClick={primary.onClick}
          >
            {primary.name}
          </AptunoButton>
        </Grid>
      </Grid>
    </ActionBarContainer>
  );
};
